/* HOM · EL RELOJ v3 — motor del tiempo.
   - Reloj vivo (HH:MM, latido) + título de pestaña vivo.
   - Cielo de 4 canales (cénit, horizonte, glow que sigue al sol, estrellas)
     interpolado por minuto. El MODO sale de la LUMINANCIA real del cielo:
     el texto cambia de tinta/papel exactamente cuando la luz cruza el umbral.
   - Arco reencuadrado (CX 360, CY 432, R 336 — ápice y=96, siempre visible).
     Drag solo desde el sol/luna o el arco (no secuestra taps del cielo).
     Etiqueta "arrastra" hasta el primer toque + nudge de invitación.
   - Buy box: contrato v5 INTACTO (radios data-* -> precio/CTA/sticky + cart/add.js).
   - Sin JS: página en AM con 06:40 estático y compra por submit nativo. */
(function () {
  'use strict';

  if (window.__rjArrancado) { return; }
  window.__rjArrancado = true;
  /* el estado (modo, crepúsculo, cielo) vive en <html>: las secciones son independientes */
  var root = document.documentElement;
  if (!document.querySelector('.hreloj')) { return; }

  var ANIM = window.matchMedia && matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (ANIM) { document.documentElement.classList.add('rj-anim'); }

  var params = new URLSearchParams(location.search);
  var horaForzada = null;            /* minutos 0..1439 si viene ?hora= o se arrastra */
  var modoForzado = null;            /* 'am'|'pm' si viene ?modo= */
  var m = /^(\d{1,2}):(\d{2})$/.exec(params.get('hora') || '');
  if (m) { horaForzada = (Math.min(23, +m[1]) * 60) + Math.min(59, +m[2]); }
  var mm = (params.get('modo') || '').toLowerCase();
  if (mm === 'am' || mm === 'pm') {
    modoForzado = mm;
    if (horaForzada === null) { horaForzada = (mm === 'am') ? 400 : 1350; } /* cielo coherente */
  }

  function ahoraMin() {
    if (horaForzada !== null) { return horaForzada; }
    var d = new Date();
    return d.getHours() * 60 + d.getMinutes();
  }

  /* ---------- espejos por franja (voz: espejo, no regaño) ---------- */
  function espejo(min) {
    var h = Math.floor(min / 60);
    if (h >= 5 && h < 9)  { return 'El día ya echó a andar — contigo o sin ti.'; }
    if (h >= 9 && h < 14) { return 'La mañana todavía es tuya.'; }
    if (h >= 14 && h < 18){ return '¿Ya llegaron las 3:07 de siempre?'; }
    if (h >= 18 && h < 23){ return 'El día de mañana se cierra esta noche.'; }
    return '¿Despierto a esta hora? De esto exactamente hablamos.';
  }

  /* ---------- cielo: 4 canales por parada (paleta HOM + luz fotográfica) ---------- */
  var CIELO = [
    { t: 0,    a: '#020407', b: '#0A1220', g: [255,178,122,0],   s: 1   },
    { t: 300,  a: '#030609', b: '#0F1725', g: [255,178,122,0],   s: .85 },
    { t: 352,  a: '#0B1120', b: '#2B2E36', g: [255,178,122,.14], s: .3  },
    { t: 356,  a: '#3F444E', b: '#4E4A45', g: [255,178,122,.22], s: .15 },
    { t: 360,  a: '#8E939B', b: '#9E9891', g: [255,178,122,.32], s: 0   },
    { t: 364,  a: '#C7CCD3', b: '#E9E2D6', g: [255,178,122,.42], s: 0   },
    { t: 450,  a: '#DDE1E6', b: '#F2EEE6', g: [255,178,122,.16], s: 0   },
    { t: 660,  a: '#D5DADD', b: '#E1E6EA', g: [255,255,255,0],   s: 0   },
    { t: 1020, a: '#E5E7EA', b: '#F1ECE4', g: [232,147,90,.10],  s: 0   },
    { t: 1128, a: '#C4C6CB', b: '#E3D6C6', g: [232,147,90,.38],  s: 0   },
    { t: 1132, a: '#8A8D93', b: '#9A9490', g: [232,147,90,.34],  s: 0   },
    { t: 1136, a: '#3A3E48', b: '#4A4540', g: [232,147,90,.32],  s: .1  },
    { t: 1140, a: '#20242E', b: '#3A3730', g: [232,147,90,.30],  s: .15 },
    { t: 1180, a: '#0A0F18', b: '#141B28', g: [232,147,90,.08],  s: .5  },
    { t: 1260, a: '#040710', b: '#0B1220', g: [232,147,90,0],    s: .9  },
    { t: 1440, a: '#020407', b: '#0A1220', g: [255,178,122,0],   s: 1   }
  ];
  function hex2rgb(x) { x = x.slice(1); return [parseInt(x.slice(0,2),16), parseInt(x.slice(2,4),16), parseInt(x.slice(4,6),16)]; }
  function lerp(a, b, p) { return a + (b - a) * p; }
  function mezclaRgb(c1, c2, p) { return [Math.round(lerp(c1[0],c2[0],p)), Math.round(lerp(c1[1],c2[1],p)), Math.round(lerp(c1[2],c2[2],p))]; }
  function css(c) { return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')'; }
  function luminancia(c) {
    function lin(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]);
  }
  function legible(c, claro) { /* garantía: el cielo jamás traiciona al texto del hero */
    for (var k = 0; k < 6; k++) {
      var L = luminancia(c);
      if (claro ? L >= 0.19 : L <= 0.16) { break; }
      c = claro ? c.map(function (v) { return Math.round(v + (255 - v) * 0.22); })
                : c.map(function (v) { return Math.round(v * 0.78); });
    }
    return c;
  }
  function cielo(min) {
    for (var i = 0; i < CIELO.length - 1; i++) {
      if (min >= CIELO[i].t && min <= CIELO[i+1].t) {
        var p = (min - CIELO[i].t) / Math.max(1, (CIELO[i+1].t - CIELO[i].t));
        var A = mezclaRgb(hex2rgb(CIELO[i].a), hex2rgb(CIELO[i+1].a), p);
        var B = mezclaRgb(hex2rgb(CIELO[i].b), hex2rgb(CIELO[i+1].b), p);
        var g1 = CIELO[i].g, g2 = CIELO[i+1].g;
        var G = [Math.round(lerp(g1[0],g2[0],p)), Math.round(lerp(g1[1],g2[1],p)), Math.round(lerp(g1[2],g2[2],p)), lerp(g1[3],g2[3],p)];
        var am = luminancia(mezclaRgb(A, B, 0.45)) >= 0.17;
        A = legible(A, am); B = legible(B, am);
        var LA = luminancia(A), LB = luminancia(B);
        return {
          a: css(A), b: css(B),
          ga: G,
          s: lerp(CIELO[i].s, CIELO[i+1].s, p),
          am: am,
          crep: am ? Math.min(LA, LB) < 0.60 : Math.max(LA, LB) > 0.042
        };
      }
    }
    var z = CIELO[0];
    return { a: z.a, b: z.b, ga: [0,0,0,0], s: z.s, am: false, crep: false };
  }

  /* ---------- estrellas: campo determinista (se pinta una vez) ---------- */
  (function estrellas() {
    var el = root.querySelector('.rj-estrellas');
    if (!el) { return; }
    var sombras = [];
    function azar(n) { var v = Math.sin(n) * 43758.5453123; return v - Math.floor(v); }
    for (var i = 1; i <= 70; i++) {
      var x = azar(i * 12.9898) * 96 + 2;
      var y = azar(i * 78.233) * 24 + 1;
      var brillo = (i % 3 === 0) ? 0.9 : 0.5;
      var radio = (i % 5 === 0) ? '1px' : '0';
      sombras.push(x.toFixed(2) + 'vw ' + y.toFixed(2) + 'vw 0 ' + radio + ' rgba(225,230,234,' + brillo + ')');
    }
    el.style.boxShadow = sombras.join(',');
  })();

  /* ---------- aplicar estado ---------- */
  var elHH = root.querySelector('[data-rj-hh]');
  var elMM = root.querySelector('[data-rj-mm]');
  var elMer = root.querySelector('[data-rj-meridiano]');
  var elEspejo = root.querySelector('[data-rj-espejo]');
  var elHoraCorta = root.querySelector('[data-rj-hora-corta]');
  var svg = root.querySelector('[data-rj-arco-svg]');
  var auraA = document.getElementById('rjaura-a');
  var auraB = document.getElementById('rjaura-b');

  function pinta() {
    var min = ahoraMin();
    var h = Math.floor(min / 60), mn = min % 60;
    var hhmm = (h < 10 ? '0' : '') + h + ':' + (mn < 10 ? '0' : '') + mn;
    var mer = h < 12 ? 'am' : 'pm';
    if (elHH) { elHH.textContent = h % 12 || 12; }
    if (elMM) { elMM.textContent = (mn < 10 ? '0' : '') + mn; }
    if (elMer) { elMer.textContent = mer.toUpperCase(); }
    root.dataset.meridiano = mer;
    if (elEspejo) { elEspejo.textContent = espejo(min); }
    if (elHoraCorta) { elHoraCorta.textContent = h + ':' + (mn < 10 ? '0' : '') + mn; }

    var c = cielo(min);
    /* el modo ES la luz: tinta sobre cielo claro, papel sobre cielo oscuro */
    var modo = modoForzado || (c.am ? 'am' : 'pm');
    root.dataset.modo = modo;
    root.dataset.crepusculo = c.crep ? '1' : '0';

    root.style.setProperty('--rj-cielo-a', c.a);
    root.style.setProperty('--rj-cielo-b', c.b);
    if (auraA && auraB) { /* la luz cálida sigue al sol por el arco */
      var gc = 'rgb(' + c.ga[0] + ',' + c.ga[1] + ',' + c.ga[2] + ')';
      auraA.setAttribute('stop-color', gc);
      auraA.setAttribute('stop-opacity', Math.min(0.5, c.ga[3]).toFixed(3));
      auraB.setAttribute('stop-color', gc);
    }
    root.style.setProperty('--rj-estrellas', c.s.toFixed(2));

    if (svg) { svg.setAttribute('aria-valuenow', min); svg.setAttribute('aria-valuetext', hhmm); }
    try { document.title = hhmm + ' — HOM'; } catch (e) {}
    solPinta(min);
  }
  setInterval(pinta, 15000);

  /* ---------- arco del día (drag = viaje en el tiempo) ---------- */
  var sol = root.querySelector('[data-rj-sol]');
  var marcaAM = root.querySelector('[data-rj-marca-am]');
  var marcaPM = root.querySelector('[data-rj-marca-pm]');
  var btnVolver = root.querySelector('[data-rj-volver]');
  var notaArco = root.querySelector('[data-rj-arco-nota]');
  var CX = 360, CY = 432, R = 336;
  var AL = Math.atan2(CY - 330, 40 - CX);   /* extremo izquierdo (00 h) */
  var AR = Math.atan2(CY - 330, 680 - CX);  /* extremo derecho (24 h) */

  function xyDeMin(min) {
    var ang = AL - (min / 1440) * (AL - AR);
    return [CX + R * Math.cos(ang), CY - R * Math.sin(ang)];
  }
  function solPinta(min) {
    if (!sol) { return; }
    var p = xyDeMin(min);
    sol.setAttribute('transform', 'translate(' + p[0].toFixed(1) + ',' + p[1].toFixed(1) + ')');
  }
  function marca(el, min) {
    if (!el) { return; }
    var p = xyDeMin(min);
    el.setAttribute('transform', 'translate(' + p[0].toFixed(1) + ',' + p[1].toFixed(1) + ')');
  }
  marca(marcaAM, 6 * 60 + 40);
  marca(marcaPM, 22 * 60 + 30);

  function coordsSvg(ev) {
    var r = svg.getBoundingClientRect();
    var cx = ev.touches ? ev.touches[0].clientX : ev.clientX;
    var cy = ev.touches ? ev.touches[0].clientY : ev.clientY;
    return [(cx - r.left) / r.width * 720, (cy - r.top) / r.height * 400];
  }
  function minDeXY(x, y) {
    var ang = Math.atan2(CY - y, x - CX);
    ang = Math.max(AR, Math.min(AL, ang));
    var min = Math.round((AL - ang) / (AL - AR) * 1440);
    return Math.max(0, Math.min(1439, min));
  }
  function viaja(min) {
    horaForzada = min;
    root.classList.add('rj-toco');
    nudgeMuerto = true;
    if (btnVolver) { btnVolver.hidden = false; }
    if (notaArco) { notaArco.textContent = 'Estás viajando en el día. La página vive esta hora, no la tuya.'; }
    pinta();
  }
  var nudgeMuerto = false;
  if (svg) {
    var arrastrando = false;
    svg.addEventListener('pointerdown', function (ev) {
      var c = coordsSvg(ev);
      var p = xyDeMin(ahoraMin());
      var dSol = Math.hypot(c[0] - p[0], c[1] - p[1]);
      var dArco = Math.abs(Math.hypot(c[0] - CX, c[1] - CY) - R);
      /* solo el sol o el arco inician el viaje: el cielo no secuestra taps */
      if (dSol < 56 || (dArco < 38 && c[1] < 342)) {
        arrastrando = true;
        try { svg.setPointerCapture(ev.pointerId); } catch (e) {}
        ev.preventDefault();
        viaja(minDeXY(c[0], c[1]));
      }
    });
    svg.addEventListener('pointermove', function (ev) {
      if (arrastrando) { var c = coordsSvg(ev); viaja(minDeXY(c[0], c[1])); }
    });
    svg.addEventListener('pointerup', function () { arrastrando = false; });
    svg.addEventListener('pointercancel', function () { arrastrando = false; });
    svg.addEventListener('keydown', function (ev) {
      var paso = ev.shiftKey ? 60 : 15;
      if (ev.key === 'ArrowRight') { ev.preventDefault(); viaja((ahoraMin() + paso) % 1440); }
      if (ev.key === 'ArrowLeft')  { ev.preventDefault(); viaja((ahoraMin() - paso + 1440) % 1440); }
    });

    /* nudge de invitación: el sol se mece una vez si nadie lo ha tocado */
    if (ANIM) {
      setTimeout(function () {
        if (nudgeMuerto || root.classList.contains('rj-toco')) { return; }
        var t0 = null, DUR = 1600, base = ahoraMin();
        function paso(ts) {
          if (nudgeMuerto) { solPinta(ahoraMin()); return; }
          if (t0 === null) { t0 = ts; }
          var p = (ts - t0) / DUR;
          if (p >= 1) { solPinta(base); return; }
          solPinta(base + Math.sin(p * Math.PI * 2) * 16);
          requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, 2500);
    }
  }
  if (btnVolver) {
    btnVolver.addEventListener('click', function () {
      horaForzada = null; modoForzado = null;
      btnVolver.hidden = true;
      if (notaArco) { notaArco.textContent = 'Este es tu momento del día.'; }
      pinta();
    });
  }

  /* ---------- el momento: el slider descubre el mundo AM o PM (solo esta sección) ---------- */
  (function sliderMomento() {
    var fig = root.querySelector('[data-rj-slider]');
    if (!fig) { return; }
    var rango = fig.querySelector('[data-rj-slider-range]');
    if (!rango) { return; }
    var tocado = false;
    function syncSlider() {
      fig.style.setProperty('--compare', rango.value);
      fig.dataset.mundo = (+rango.value >= 50) ? 'am' : 'pm';
    }
    /* escritorio abre en 50/50 (los dos mundos a la vista); móvil abre en el mundo del visitante */
    var movil = window.matchMedia && matchMedia('(max-width: 989px)').matches;
    var modoInicial = modoForzado || (cielo(ahoraMin()).am ? 'am' : 'pm'); /* pinta() aún no corre aquí */
    if (movil) { rango.value = (modoInicial === 'pm') ? 15 : 85; }
    var base = +rango.value;
    rango.addEventListener('input', function () { tocado = true; syncSlider(); });
    syncSlider();
    /* nudge de descubrimiento: el divisor se mece una vez al entrar en vista */
    if (ANIM && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting || tocado) { return; }
        obs.disconnect();
        fig.classList.add('rj-slider--anim');
        var paso = movil ? 10 : 12;
        [[100, base - paso], [600, base + paso], [1100, base]].forEach(function (p) {
          setTimeout(function () {
            if (tocado) { return; }
            rango.value = p[1];
            syncSlider();
          }, p[0]);
        });
        setTimeout(function () { fig.classList.remove('rj-slider--anim'); }, 1700);
      }, { threshold: 0.5 }).observe(fig);
    }
  })();

  /* ---------- garantía: las 90 marcas del sello se encienden al entrar en vista ----------
     El marcado trae rj-on (sin JS o con reduced-motion el sello se ve completo y quieto). */
  (function selloGarantia() {
    if (!ANIM || !('IntersectionObserver' in window)) { return; }
    root.querySelectorAll('[data-rj-garantia]').forEach(function (g) {
      g.classList.remove('rj-on');
      new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting) { return; }
        obs.disconnect();
        g.classList.add('rj-on');
      }, { threshold: 0.35 }).observe(g);
    });
  })();

  /* ---------- fundadores: frases del espejo (cada una que marca es un «sí») ---------- */
  root.querySelectorAll('[data-rj-frase]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
  });

  /* ---------- fundadores: puntos de los carruseles (en celular las tarjetas se deslizan) ---------- */
  root.querySelectorAll('[data-rj-carrusel]').forEach(function (tira) {
    var puntos = tira.nextElementSibling;
    if (!puntos || !puntos.hasAttribute('data-rj-puntos')) { return; }
    var tarjetas = [].slice.call(tira.children);
    puntos.innerHTML = tarjetas.map(function (_, i) { return '<i' + (i === 0 ? ' class="rj-on"' : '') + '></i>'; }).join('');
    var marcas = [].slice.call(puntos.children);
    tira.addEventListener('scroll', function () {
      var centro = tira.scrollLeft + tira.clientWidth / 2, mejor = 0, dist = Infinity;
      tarjetas.forEach(function (t, i) {
        var d = Math.abs(t.offsetLeft + t.offsetWidth / 2 - centro);
        if (d < dist) { dist = d; mejor = i; }
      });
      marcas.forEach(function (m, i) { m.classList.toggle('rj-on', i === mejor); });
    }, { passive: true });
  });

  /* ---------- buy box (contrato v5 — NO TOCAR) ---------- */
  function track(name, payload) {
    try { if (typeof window.homTrack === 'function') { window.homTrack(name, payload || {}); } } catch (e) {}
    /* eventos de cliente de Shopify: el píxel personalizado los reenvía a Meta (hom_<Nombre>) */
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish('hom_' + name, payload || {}); } } catch (e) {}
  }
  var radios = [].slice.call(root.querySelectorAll('[data-plan]'));
  function applyPlan(value, source) {
    var model = null;
    radios.forEach(function (r) {
      r.checked = (r.value === value);
      if (r.checked && !model) { model = r.dataset; }
    });
    if (!model) { return; }
    root.querySelectorAll('[data-price-view]').forEach(function (n) { n.textContent = model.price || ''; });
    root.querySelectorAll('[data-per-view]').forEach(function (n) { n.textContent = model.per || ''; });
    root.querySelectorAll('[data-cta-price]').forEach(function (n) { n.textContent = model.cta || model.price || ''; });
    root.querySelectorAll('[data-sticky-price]').forEach(function (n) { n.textContent = model.bar || model.price || ''; });
    root.querySelectorAll('[data-hom-form]').forEach(function (form) {
      var v = form.querySelector('[data-hom-variant]');
      var p = form.querySelector('[data-hom-plan-input]');
      var q = form.querySelector('[data-hom-qty]');
      if (v && model.variant) { v.value = model.variant; }
      if (q) { q.value = model.qty || '1'; }
      if (p) { p.value = model.sellingPlan || ''; p.disabled = !model.sellingPlan; }
    });
    if (source === 'user') { track('PlanSelected', { plan: value, variant: model.variant || '' }); }
  }
  radios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) { applyPlan(r.value, 'user'); } });
  });
  var initial = radios.filter(function (r) { return r.checked; })[0] || radios[0];
  if (initial) { applyPlan(initial.value, 'init'); }
  /* ?plan=tri|sub|once (links de la lectura y de WhatsApp): llega con su plan elegido y frente a la compra */
  var planUrl = (params.get('plan') || '').toLowerCase();
  if (/^(tri|sub|once)$/.test(planUrl) && radios.some(function (r) { return r.value === planUrl; })) {
    applyPlan(planUrl, 'url');
    var cajaCompra = document.getElementById('rj-buy');
    if (cajaCompra) { window.addEventListener('load', function () { cajaCompra.scrollIntoView({ block: 'start' }); }); }
  }
  /* botones que llevan a la compra con un plan elegido (la garantía aplica solo a Tres meses) */
  root.querySelectorAll('[data-rj-plan]').forEach(function (a) {
    a.addEventListener('click', function () { applyPlan(a.getAttribute('data-rj-plan'), 'user'); });
  });

  /* ---------- vistas para retargeting: una vez por carga (hom_VioCaja, hom_VioGarantia, hom_VioFundadores) ---------- */
  (function vistas() {
    if (!('IntersectionObserver' in window)) { return; }
    [['#rj-buy', 'VioCaja'], ['[data-rj-garantia]', 'VioGarantia'], ['.rj-fd', 'VioFundadores']].forEach(function (par) {
      var el = root.querySelector(par[0]);
      if (!el) { return; }
      new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting) { return; }
        obs.disconnect();
        track(par[1], {});
      }, { threshold: 0.35 }).observe(el);
    });
  })();

  /* ---------- popups: lectura (captura) y garantía (objeción) ----------
     Máximo uno por visita.
     · Lectura: a quien no ha dejado su WhatsApp. Sale con lo que pase primero: N s activos (pestaña
       visible; moverse NO reinicia el reloj), X % de la página leído o intención de salir. Por
       tiempo o lectura nunca sale con la caja de compra en pantalla: espera a que salga de ella.
       Si lo cierra: H horas sin abrirse solo y queda la pestañita que lo reabre.
     · Garantía: solo a quien ya dejó su WhatsApp, al intentar salir después de ver los precios.
     · Agregar al carrito apaga todo; con carrito las secciones ni se pintan (Liquid).
     Tiempos con sustento (mejor conversión entre 6 y 15 s): Omnisend, Wisepops, Sleeknote.
     Va antes del manejador de anclas: los botones cierran el diálogo y luego bajan a la compra.
     · Después del WhatsApp: la lectura HOM (consentimiento → 8 preguntas del motor → leyendo →
       lectura = venta). Las respuestas de salud van SOLO al motor (ritual.healthofmen.com.mx);
       a Meta solo le llega que terminó, con su énfasis y plan.
     Pruebas: ?pop=coach · ?pop=lectura · ?pop=garantia · ?pop=reset */
  (function popups() {
    function lee(s, k) { try { return window[s].getItem(k); } catch (e) { return null; } }
    function guarda(s, k, v) { try { window[s].setItem(k, v); } catch (e) {} }
    function borra(s, k) { try { window[s].removeItem(k); } catch (e) {} }
    var LEAD = 'rjLead', SESION = 'rjPopSesion', CERRADO = 'rjCoachCerrado', GAR = 'rjPopGarantia', QUEDAN = 'rjQuedan';
    var prueba = (params.get('pop') || '').toLowerCase();
    if (prueba === 'reset') {
      [LEAD, CERRADO, GAR, QUEDAN, 'rjVisitas', 'rjPopLead', 'rjTel', 'rjLecturaHecha'].forEach(function (k) { borra('localStorage', k); });
      [SESION, 'rjVisitaContada', 'rjDelta', 'rjUtm'].forEach(function (k) { borra('sessionStorage', k); });
    }
    var coach = root.querySelector('[data-rj-coach]');
    var gar = root.querySelector('[data-rj-pop]');
    var tab = root.querySelector('[data-rj-tab]');
    var buy = root.querySelector('#rj-buy');
    var lead = !!lee('localStorage', LEAD);
    var telLead = lee('localStorage', 'rjTel');
    var hecha = !!lee('localStorage', 'rjLecturaHecha');
    /* de dónde vino (primer toque de la sesión): viaja con la lectura a la base de HOM */
    if (params.get('utm_source') && !lee('sessionStorage', 'rjUtm')) {
      guarda('sessionStorage', 'rjUtm', JSON.stringify({ utm_source: params.get('utm_source'), utm_medium: params.get('utm_medium') || '', utm_campaign: params.get('utm_campaign') || '' }));
    }

    function abre(d) {
      if (!d || d.open || typeof d.showModal !== 'function') { return false; }
      if (ANIM) { d.classList.add('rj-apagado'); }
      d.showModal();
      if (ANIM) { requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.remove('rj-apagado'); }); }); }
      /* foco en el título visible (no en la X) */
      var h = [].slice.call(d.querySelectorAll('.rj-pop__h')).filter(function (x) { return x.offsetParent !== null; })[0];
      if (h) { h.focus(); }
      return true;
    }

    /* visitas: una por sesión del navegador */
    var visitas = 1, nuevaVisita = false;
    try {
      visitas = +localStorage.getItem('rjVisitas') || 0;
      if (!sessionStorage.getItem('rjVisitaContada')) {
        visitas += 1;
        nuevaVisita = true;
        localStorage.setItem('rjVisitas', String(visitas));
        sessionStorage.setItem('rjVisitaContada', '1');
      }
    } catch (e) { visitas = 1; }

    /* lugares apartados desde la última visita (resta real del contador) */
    var quedanHoy = coach ? parseInt(coach.dataset.quedan, 10) : NaN;
    if (!isNaN(quedanHoy)) {
      if (nuevaVisita) {
        var antes = parseInt(lee('localStorage', QUEDAN), 10);
        guarda('sessionStorage', 'rjDelta', (!isNaN(antes) && antes > quedanHoy) ? String(antes - quedanHoy) : '0');
        guarda('localStorage', QUEDAN, String(quedanHoy));
      }
      var delta = coach.querySelector('[data-rj-delta]');
      var nDelta = +lee('sessionStorage', 'rjDelta') || 0;
      if (delta && visitas >= 2 && nDelta > 0) {
        delta.textContent = (delta.getAttribute('data-plantilla') || '').replace('[n]', nDelta.toLocaleString('es-MX'));
        delta.hidden = false;
      }
    }

    /* ---- envío del lead (intermediario propio → Klaviyo con permiso de WhatsApp) ---- */
    function ok2xx(r) { if (!r.ok) { throw new Error('lead ' + r.status); } return r; }
    function enviaLead(cfg, tel, props, trampa) {
      if (window.Shopify && window.Shopify.designMode) { return Promise.resolve(); }
      if (cfg.relay) {
        return fetch(cfg.relay, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          tel: tel, email: '', consentimiento: true, web: trampa || '', props: props
        }) }).then(ok2xx);
      }
      /* respaldo: API de cliente de Klaviyo (solo el evento; el permiso de WhatsApp necesita el intermediario) */
      if (!cfg.k) { return Promise.reject(new Error('sin destino')); }
      return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(cfg.k), {
        method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: cfg.metrica } } },
          profile: { data: { type: 'profile', attributes: { phone_number: tel } } }
        } } })
      }).then(ok2xx);
    }
    function yaEsLead(tel) {
      lead = true;
      telLead = tel;
      guarda('localStorage', LEAD, '1');
      guarda('localStorage', 'rjTel', tel);
      if (tab) { tab.hidden = true; }
    }
    document.addEventListener('submit', function (ev) {
      var f = ev.target.closest && ev.target.closest('[data-rj-lead]');
      if (!f) { return; }
      ev.preventDefault();
      var err = f.querySelector('[data-rj-lead-err]');
      var tel = (f.elements.tel.value || '').replace(/\D/g, '');
      if (tel.length === 12 && tel.indexOf('52') === 0) { tel = tel.slice(2); }
      if (tel.length !== 10) { err.textContent = 'Escribe tu WhatsApp a 10 dígitos.'; f.elements.tel.focus(); return; }
      err.textContent = '';
      var btn = f.querySelector('[type="submit"]');
      btn.disabled = true;
      var legal = f.querySelector('[data-rj-legal]');
      var props = {
        origen: f.getAttribute('data-origen') || 'popup', via: f.getAttribute('data-via') || '', visita: visitas,
        quedan: isNaN(quedanHoy) ? '' : String(quedanHoy), pagina: location.pathname,
        consentimiento: legal ? legal.textContent.replace(/\s+/g, ' ').trim() : '', consentimiento_fecha: new Date().toISOString()
      };
      enviaLead(f.dataset, '+52' + tel, props, f.elements.web ? f.elements.web.value : '').then(function () {
        yaEsLead('+52' + tel);
        track('Lead', { origen: props.origen, via: props.via, visita: visitas });
        /* con WhatsApp en la mano sigue la lectura: en el popup, o abriéndolo desde la captura bajo precios */
        var dlg = f.closest('dialog');
        if (coach && (dlg === coach || !dlg)) {
          if (dlg) { dlg.dataset.salida = 'lead'; vista('intro'); }
          else {
            var cajaCap = f.closest('[data-rj-lead-caja]');
            var secCap = f.closest('.shopify-section');
            if (secCap) { secCap.style.display = 'none'; }
            else if (cajaCap) { cajaCap.hidden = true; }
            abreCoach('captura', 'intro');
          }
          cargaPreguntas();
          return;
        }
        var caja = f.closest('[data-rj-lead-caja]');
        var ok = caja && caja.parentNode.querySelector('[data-rj-lead-ok]');
        var d = f.closest('dialog');
        if (d) { d.dataset.salida = 'lead'; }
        if (caja && ok) {
          caja.hidden = true;
          ok.hidden = false;
          var h = ok.querySelector('.rj-pop__h, .rj-cap__h');
          if (h) { h.focus(); }
        }
      })['catch'](function () {
        err.textContent = 'No se pudo enviar. Intenta de nuevo en un momento.';
      }).then(function () { btn.disabled = false; });
    });
    /* quien ya dejó su WhatsApp no ve la captura bajo los precios */
    if (lead) {
      root.querySelectorAll('[data-rj-captura]').forEach(function (s) {
        var sec = s.closest('.shopify-section') || s;
        if (!(window.Shopify && window.Shopify.designMode)) { sec.style.display = 'none'; }
      });
    }

    /* ---- cerrar: X, "Seguir viendo", tocar fuera (Esc lo da el navegador) ---- */
    document.addEventListener('click', function (ev) {
      var d = ev.target.closest && ev.target.closest('dialog.rj-pop');
      if (!d || !d.open) { return; }
      if (ev.target === d) {
        var r = d.getBoundingClientRect();
        if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) { d.close(); }
        return;
      }
      if (ev.target.closest('[data-rj-pop-cerrar]')) { d.close(); }
    });
    /* los botones de compra: cierran primero (se registran antes que el scroll suave de las anclas) */
    root.querySelectorAll('dialog.rj-pop [data-rj-pop-cta]').forEach(function (a) {
      a.addEventListener('click', function () {
        var d = a.closest('dialog');
        if (!d || !d.open) { return; }
        d.dataset.salida = d.dataset.salida === 'lead' ? 'lead' : 'cta';
        /* el botón de la lectura lleva el plan que eligieron las reglas */
        if (a.hasAttribute('data-rj-l-cta') && a.getAttribute('data-plan')) { applyPlan(a.getAttribute('data-plan'), 'user'); }
        track(d === coach ? 'CoachClicCompra' : 'GarantiaPopupClic', {});
        d.close();
      });
    });

    /* ---- popup de lectura: vistas + pestañita ---- */
    /* form (WhatsApp) · gracias (venta) · intro (consentimiento) · paso (pregunta) · leyendo · lectura */
    function vista(nombre) {
      if (!coach) { return; }
      coach.querySelectorAll('[data-rj-vista]').forEach(function (v) { v.hidden = v.getAttribute('data-rj-vista') !== nombre; });
      coach.classList.toggle('rj-pop--lectura', nombre === 'lectura');
      coach.dataset.vista = nombre;
      if (coach.open) {
        var v = coach.querySelector('[data-rj-vista="' + nombre + '"] .rj-pop__h');
        if (v) { v.focus(); }
        coach.scrollTop = 0;
      }
    }
    function vistaInicial() {
      if (!lead) { return 'form'; }
      return telLead && !hecha ? 'intro' : 'gracias';
    }
    function abreCoach(motivo, forzada) {
      if (!coach) { return; }
      vista(forzada || vistaInicial());
      var f = coach.querySelector('[data-rj-lead]');
      if (f) { f.setAttribute('data-via', motivo === 'pestana' ? 'pestana' : ''); }
      if (tab) { tab.hidden = true; }
      if (coach.dataset.vista === 'intro') { cargaPreguntas(); }
      if (abre(coach)) { track('CoachVisto', { motivo: motivo, visita: visitas }); }
    }
    function pintaTab() {
      if (!tab || !coach) { return; }
      var pendiente = lead && telLead && !hecha;
      var span = tab.querySelector('span');
      if (pendiente && tab.getAttribute('data-pendiente') && span) {
        if (!tab.dataset.texto) { tab.dataset.texto = span.textContent; }
        span.textContent = tab.getAttribute('data-pendiente');
      }
      tab.hidden = !(pendiente || (!lead && lee('localStorage', CERRADO)));
    }
    if (coach) {
      coach.addEventListener('close', function () {
        var salida = coach.dataset.salida;
        coach.dataset.salida = '';
        if (!lead && salida !== 'cta') {
          guarda('localStorage', CERRADO, String(Date.now()));
          track('CoachCerrado', {});
        }
        if (lead && coach.dataset.vista === 'paso') { track('LecturaAbandonada', { paso: Q.i + 1 }); }
        pintaTab();
      });
    }
    if (tab) {
      pintaTab();
      tab.addEventListener('click', function () { track('PestanaClic', {}); abreCoach('pestana'); });
    }
    /* la sección 08 todavía enlaza a la página vieja del Coach: se abre aquí mismo */
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href*="ritual.healthofmen.com.mx/coach"], [data-rj-abre-lectura]');
      if (!a || !coach) { return; }
      ev.preventDefault();
      abreCoach('seccion');
    });

    /* ---- la lectura HOM: preguntas del motor → respuestas → lectura ---- */
    var api = coach ? (coach.getAttribute('data-api') || 'https://ritual.healthofmen.com.mx').replace(/\/+$/, '') : '';
    var Q = { preguntas: null, i: 0, resp: {}, t0: 0, cargando: null };
    function cargaPreguntas() {
      if (Q.preguntas) { return Promise.resolve(Q.preguntas); }
      if (!Q.cargando) {
        Q.cargando = fetch(api + '/api/lectura/preguntas').then(function (r) { if (!r.ok) { throw new Error('preguntas ' + r.status); } return r.json(); })
          .then(function (j) { Q.preguntas = j.preguntas || []; return Q.preguntas; });
        Q.cargando['catch'](function () { Q.cargando = null; });
      }
      return Q.cargando;
    }
    function pintaPregunta() {
      var p = Q.preguntas[Q.i];
      var n = Q.preguntas.length;
      coach.querySelector('[data-rj-q-n]').textContent = (Q.i + 1) + ' de ' + n;
      coach.querySelector('[data-rj-q-barra]').style.width = ((Q.i + 1) / n * 100) + '%';
      coach.querySelector('[data-rj-q-texto]').textContent = p.texto;
      var ops = coach.querySelector('[data-rj-q-ops]');
      while (ops.firstChild) { ops.removeChild(ops.firstChild); }
      p.opciones.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rj-lq__op';
        b.textContent = o.etiqueta;
        b.setAttribute('aria-pressed', String(Q.resp[p.id] !== undefined && String(Q.resp[p.id]) === String(o.valor)));
        b.addEventListener('click', function () {
          Q.resp[p.id] = o.valor;
          b.setAttribute('aria-pressed', 'true');
          Q.i += 1;
          setTimeout(function () { if (Q.i < Q.preguntas.length) { pintaPregunta(); } else { enviaLectura(); } }, 140);
        });
        ops.appendChild(b);
      });
      vista('paso');
    }
    function errorIntro(msg) {
      var e = coach.querySelector('[data-rj-q-err]');
      if (e) { e.textContent = msg; }
    }
    if (coach) {
      var empezar = coach.querySelector('[data-rj-q-empezar]');
      if (empezar) {
        empezar.addEventListener('click', function () {
          errorIntro('');
          empezar.disabled = true;
          cargaPreguntas().then(function () {
            Q.i = 0; Q.resp = {}; Q.t0 = Date.now();
            track('LecturaEmpezada', {});
            pintaPregunta();
          })['catch'](function () { errorIntro('No pudimos cargar tus preguntas. Intenta de nuevo en un momento.'); })
            .then(function () { empezar.disabled = false; });
        });
      }
      var ahora = coach.querySelector('[data-rj-q-ahora]');
      if (ahora) { ahora.addEventListener('click', function () { track('LecturaAhoraNo', {}); vista('gracias'); }); }
      var atras = coach.querySelector('[data-rj-q-atras]');
      if (atras) { atras.addEventListener('click', function () { if (Q.i > 0) { Q.i -= 1; pintaPregunta(); } else { vista('intro'); } }); }
      var reintentar = coach.querySelector('[data-rj-q-reintentar]');
      if (reintentar) { reintentar.addEventListener('click', function () { enviaLectura(); }); }
    }
    function metaLectura() {
      var utm = {};
      try { utm = JSON.parse(lee('sessionStorage', 'rjUtm') || '{}') || {}; } catch (e) {}
      return {
        visita: visitas, segundos: Math.round((Date.now() - Q.t0) / 1000),
        modo: root.getAttribute('data-modo') === 'pm' ? 'pm' : 'am', hora_local: new Date().getHours(),
        dispositivo: window.matchMedia && window.matchMedia('(pointer: coarse)').matches ? 'celular' : 'compu',
        fundador: coach.getAttribute('data-fundador') || '', referrer: document.referrer || '',
        utm_source: utm.utm_source || '', utm_medium: utm.utm_medium || '', utm_campaign: utm.utm_campaign || ''
      };
    }
    function enviaLectura() {
      vista('leyendo');
      var e2 = coach.querySelector('[data-rj-q-err2]');
      var re = coach.querySelector('[data-rj-q-reintentar]');
      if (e2) { e2.textContent = ''; }
      if (re) { re.hidden = true; }
      var t = Date.now();
      fetch(api + '/api/lectura', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ acepta: true, tel: telLead, respuestas: Q.resp, meta: metaLectura() })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.ok) { throw new Error(j.error || 'lectura'); } return j; }); })
        .then(function (j) {
          /* "Leyendo…" se queda al menos 1.5 s: menos se siente a plantilla, más estorba */
          setTimeout(function () {
            pintaLectura(j);
            hecha = true;
            guarda('localStorage', 'rjLecturaHecha', '1');
            /* a Meta solo va que terminó, con su énfasis y plan: nunca sus respuestas */
            track('LecturaCompleta', { enfasis: j.enfasis, plan: j.plan });
          }, Math.max(0, 1500 - (Date.now() - t)));
        })['catch'](function (err) {
          if (e2) { e2.textContent = (err && err.message && err.message.length < 120 && err.message !== 'lectura') ? err.message : 'No pudimos leer tus respuestas. Intenta de nuevo.'; }
          if (re) { re.hidden = false; }
        });
    }
    function pintaLectura(j) {
      coach.querySelector('[data-rj-l-espejo]').textContent = j.espejo || '';
      var cajaDatos = coach.querySelector('[data-rj-l-datos-caja]');
      var lista = coach.querySelector('[data-rj-l-datos]');
      while (lista.firstChild) { lista.removeChild(lista.firstChild); }
      (j.datos || []).forEach(function (d) {
        var fila = document.createElement('div');
        fila.className = 'rj-le__dato';
        var b = document.createElement('b');
        b.textContent = d.grande;
        var p = document.createElement('p');
        var i = d.fuerte ? d.texto.indexOf(d.fuerte) : -1;
        if (i >= 0) {
          p.appendChild(document.createTextNode(d.texto.slice(0, i)));
          var s = document.createElement('strong');
          s.textContent = d.fuerte;
          p.appendChild(s);
          p.appendChild(document.createTextNode(d.texto.slice(i + d.fuerte.length)));
        } else { p.textContent = d.texto; }
        fila.appendChild(b);
        fila.appendChild(p);
        lista.appendChild(fila);
      });
      cajaDatos.hidden = !(j.datos && j.datos.length);
      coach.querySelector('[data-rj-l-caso]').textContent = j.caso || '';
      var ri = j.ritual || {};
      coach.querySelector('[data-rj-l-am-t]').textContent = (ri.am && ri.am.titulo) || '';
      coach.querySelector('[data-rj-l-am]').textContent = (ri.am && ri.am.texto) || '';
      coach.querySelector('[data-rj-l-pm-t]').textContent = (ri.pm && ri.pm.titulo) || '';
      coach.querySelector('[data-rj-l-pm]').textContent = (ri.pm && ri.pm.texto) || '';
      var cta = coach.querySelector('[data-rj-l-cta]');
      if (cta) { cta.setAttribute('data-plan', j.plan === 'tri' ? 'tri' : 'sub'); }
      var gar2 = coach.querySelector('[data-rj-l-gar]');
      if (gar2) { gar2.hidden = j.plan !== 'tri'; }
      vista('lectura');
    }
    if (gar) {
      gar.addEventListener('close', function () {
        if (gar.dataset.salida !== 'cta') {
          guarda('localStorage', GAR, String(Date.now()));
          track('GarantiaPopupCerrado', {});
        }
        gar.dataset.salida = '';
      });
    }

    /* editor de Shopify: se abren al seleccionar su sección, nunca solos */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        var d = e.target.querySelector('dialog.rj-pop');
        if (d) { if (d === coach) { vista(vistaInicial()); } abre(d); }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        var d = e.target.querySelector('dialog.rj-pop');
        if (d && d.open) { d.close(); }
      });
      return;
    }

    /* pruebas sin esperar */
    if (prueba === 'coach' && coach) { abreCoach('prueba'); return; }
    if (prueba === 'lectura' && coach) { abreCoach('enlace'); return; }
    if (prueba === 'garantia' && gar) { abre(gar); return; }

    /* ---- reglas de disparo ---- */
    var autoCoach = !!coach && !lead && typeof coach.showModal === 'function';
    var horas = +(coach && coach.dataset.horas) || 48;
    var cerrado = +lee('localStorage', CERRADO) || 0;
    if (cerrado && Date.now() - cerrado < horas * 36e5) { autoCoach = false; }
    var autoGar = !!gar && lead && typeof gar.showModal === 'function';
    var dias = +(gar && gar.dataset.dias) || 7;
    var garCerrado = +lee('localStorage', GAR) || 0;
    if (garCerrado && Date.now() - garCerrado < dias * 864e5) { autoGar = false; }
    if (lee('sessionStorage', SESION)) { autoCoach = false; autoGar = false; }
    if (!autoCoach && !autoGar) { return; }

    var hecho = false, bloqueado = false, pendiente = '', enCaja = false, vioPrecio = false;
    var seg = (+(coach && coach.dataset.seg) || 10) * 1000;
    var pct = +(coach && coach.dataset.scroll) || 40;
    var activo = 0, marca = Date.now(), visible = document.visibilityState !== 'hidden', oculto = 0;
    /* agregar al carrito apaga los popups de esta visita */
    root.querySelectorAll('[data-hom-form]').forEach(function (f) { f.addEventListener('submit', function () { bloqueado = true; }); });
    document.addEventListener('click', function (ev) { if (ev.target.closest && ev.target.closest('[data-atc]')) { bloqueado = true; } }, true);

    function dispara(motivo) {
      if (hecho || bloqueado) { return; }
      if (activo < 3000) { return; }
      var salida = motivo === 'salida' || motivo === 'sube' || motivo === 'regreso';
      if (autoCoach) {
        if (!salida && enCaja) { pendiente = motivo; return; }
        hecho = true;
        guarda('sessionStorage', SESION, '1');
        abreCoach(motivo);
        return;
      }
      if (autoGar && salida && vioPrecio) {
        hecho = true;
        guarda('sessionStorage', SESION, '1');
        if (abre(gar)) { track('GarantiaPopupVisto', { motivo: motivo, visita: visitas }); }
      }
    }
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        enCaja = e[0].intersectionRatio >= 0.2;
        if (enCaja) { vioPrecio = true; }
        if (!enCaja && pendiente) { var m = pendiente; pendiente = ''; dispara(m); }
      }, { threshold: [0, 0.2] }).observe(buy);
    }
    /* reloj de tiempo activo: solo corre con la pestaña visible */
    var reloj = setInterval(function () {
      var ahora = Date.now();
      if (visible) { activo += ahora - marca; }
      marca = ahora;
      if (hecho) { clearInterval(reloj); return; }
      if (autoCoach && activo >= seg && !pendiente) { dispara('tiempo'); }
    }, 500);
    document.addEventListener('visibilitychange', function () {
      var ahora = Date.now();
      if (visible) { activo += ahora - marca; }
      marca = ahora;
      visible = document.visibilityState !== 'hidden';
      if (!visible) { oculto = ahora; return; }
      if (oculto && ahora - oculto >= 10000) { dispara('regreso'); }
      oculto = 0;
    });
    /* quién se desplaza: en celular la ventana; en compu el tema bloquea html/body y desplaza .page-wrapper */
    var desplazador;
    function scroller() {
      if (desplazador === undefined) {
        var pw = document.querySelector('.page-wrapper');
        desplazador = (pw && pw.scrollHeight > pw.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(pw).overflowY)) ? pw : null;
      }
      return desplazador;
    }
    window.addEventListener('resize', function () { desplazador = undefined; }, { passive: true });
    function posY() { var s = scroller(); return s ? s.scrollTop : window.scrollY; }
    /* % de la página leído */
    function leido() {
      var s = scroller();
      var alto = s ? s.scrollHeight - s.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
      return alto > 0 ? (posY() / alto) * 100 : 0;
    }
    /* intención de salir: en compu el cursor sale por arriba; en celular sube rápido (≥ 60 % de pantalla en < 700 ms) */
    document.addEventListener('mouseout', function (ev) {
      if (!ev.relatedTarget && ev.clientY <= 0) { dispara('salida'); }
    });
    /* un clic en un ancla (p. ej. «Aparta tu lugar» → precios) mueve la página sola: eso no es querer salir */
    var anclaHasta = 0;
    document.addEventListener('click', function (ev) { if (ev.target.closest && ev.target.closest('a[href^="#"]')) { anclaHasta = Date.now() + 2000; } }, true);
    var huella = [];
    /* en captura: el scroll de un elemento no burbujea, pero sí pasa por document en la fase de captura */
    document.addEventListener('scroll', function () {
      if (hecho) { return; }
      var t = Date.now(), y = posY();
      if (autoCoach && !pendiente && leido() >= pct) { dispara('lectura'); }
      huella.push([t, y]);
      while (huella.length && t - huella[0][0] > 700) { huella.shift(); }
      var alto = 0;
      huella.forEach(function (h) { if (h[1] > alto) { alto = h[1]; } });
      if (alto - y >= window.innerHeight * 0.6 && t > anclaHasta) { dispara('sube'); }
    }, { passive: true, capture: true });
  })();

  root.querySelectorAll('[data-hom-form]').forEach(function (form) {
    var errBox = form.querySelector('[data-hom-error]');
    form.addEventListener('submit', function (ev) {
      if (!window.fetch || !window.FormData) { return; }
      ev.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; }
      if (errBox) { errBox.textContent = ''; }
      var fd = new FormData(form);
      var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
      fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error((res.body && res.body.description) || 'No se pudo agregar al carrito.'); }
          track('AddToCart', {});
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          if (errBox) { errBox.textContent = err.message || 'No se pudo agregar al carrito. Intenta de nuevo.'; }
          else { form.submit(); }
        })
        .then(function () { if (btn) { btn.disabled = false; } });
    });
  });

  /* ---------- sticky ---------- */
  var bar = document.getElementById('rj-sticky');
  var heroCta = root.querySelector('.rj-buy [data-atc]');
  if (bar && heroCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      var show = !e[0].isIntersecting;
      bar.classList.toggle('rj-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      root.classList.toggle('rj-sticky-on', show); /* la pestañita se sube arriba de la barra */
    }, { threshold: 0 }).observe(heroCta);
  }

  /* anclas suaves (incluye el ghost-CTA del hero) */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) { ev.preventDefault(); t.scrollIntoView(ANIM ? { behavior: 'smooth' } : {}); }
    });
  });

  pinta();
})();
